import styled from 'styled-components'

export const Price = styled.span``
